var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidgetAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 7,
    height: 7,
    rx: 1,
    stroke: "#222222",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 7,
    height: 7,
    rx: 1,
    stroke: "#222222",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 3,
    width: 7,
    height: 7,
    rx: 1,
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.0002L17.5 21.0004",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 17.5001L14 17.5001",
    stroke: "#222222",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetAdd);
export default __webpack_public_path__ + "static/media/widget-add.587cd5bede04cc6819b603da5d9d1e46.svg";
export { ForwardRef as ReactComponent };